import React from 'react';
import { Check, Circle, AlertCircle } from 'lucide-react';

const STEPS = [
  { key: 'RASCUNHO', label: 'Rascunho' },
  { key: 'VISITA_REALIZADA', label: 'Visita' },
  { key: 'EM_PROJETACAO', label: '3D' },
  { key: 'APRESENTADO_CLIENTE', label: 'Apresentado' },
  { key: 'ORCAMENTO_PRONTO', label: 'Orçamento' },
  { key: 'ORCAMENTO_APROVADO', label: 'Aprovado' }
];

const SurveyFlowProgress = ({ currentStatus }) => {
  const getStepStatus = (stepKey, index) => {
    const currentIndex = STEPS.findIndex(s => s.key === currentStatus);

    if (currentIndex === -1) {
      if (currentStatus === 'EM_REVISAO') {
        if (stepKey === 'EM_PROJETACAO') return 'completed';
        if (stepKey === 'APRESENTADO_CLIENTE') return 'current';
        return 'pending';
      }
      if (currentStatus === 'ORCAMENTO_REPROVADO') {
        if (stepKey === 'ORCAMENTO_PRONTO') return 'rejected';
        return 'pending';
      }
      return 'pending';
    }

    if (index < currentIndex) return 'completed';
    if (index === currentIndex) return 'current';
    return 'pending';
  };

  const getIcon = (status) => {
    switch (status) {
      case 'completed':
        return <Check className="w-3 h-3" />;
      case 'current':
        return <Circle className="w-3 h-3" />;
      case 'rejected':
        return <AlertCircle className="w-3 h-3" />;
      default:
        return null;
    }
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-500 border-green-500 text-white';
      case 'current':
        return 'bg-blue-500 border-blue-500 text-white ring-2 ring-blue-200 ring-offset-1';
      case 'rejected':
        return 'bg-red-500 border-red-500 text-white';
      default:
        return 'bg-white border-gray-300 text-gray-400';
    }
  };

  const getConnectorClasses = (index) => {
    const currentIndex = STEPS.findIndex(s => s.key === currentStatus);
    if (currentIndex === -1) return 'bg-gray-200';
    return index < currentIndex ? 'bg-green-500' : 'bg-gray-200';
  };

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex items-center min-w-[600px] gap-1 p-2 bg-gray-50 rounded-lg border border-gray-200">
        {STEPS.map((step, index) => {
          const status = getStepStatus(step.key, index);

          return (
            <React.Fragment key={step.key}>
              {/* Step */}
              <div className="flex flex-col items-center gap-0.5 flex-shrink-0">
                <div
                  className={`flex items-center justify-center w-7 h-7 rounded-full border-2 ${getStepClasses(status)}`}
                  title={step.label}
                >
                  {getIcon(status)}
                </div>
                <span className={`text-xs font-medium whitespace-nowrap ${status === 'current' ? 'text-blue-600' : status === 'completed' ? 'text-green-600' : 'text-gray-400'}`}>
                  {step.label}
                </span>
              </div>

              {/* Connector */}
              {index < STEPS.length - 1 && (
                <div className={`h-0.5 flex-1 min-w-[20px] rounded ${getConnectorClasses(index)}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default SurveyFlowProgress;
